import { format } from "date-fns";

export const mapItemsPerPageSelect = () => {
    return [5, 10, 15, 20].map((opt, i) => {
        return {
            id: i,
            available: true,
            value: opt
        };
    });
};

const statusMap = {
    DELIVERED: "Delivered",
    COMPLETED: "Completed",
    IN_TRANSIT: "In transit",
    ORDER_RECEIVED: "Order received",
};

export const mapStatusTagStyles = status => {
    switch (status) {
        case statusMap.DELIVERED:
        case statusMap.ORDER_RECEIVED:
            return {
                dotColor: "#00A76A",
                backgroundColor: "#00A76A26"
            };
        case statusMap.COMPLETED:
            return {
                dotColor: "#217BBE",
                backgroundColor: "#217BBE26"
            };
        case statusMap.IN_TRANSIT:
            return {
                dotColor: "#FF9C00",
                backgroundColor: "#FF9C0026"
            };
        default:
            return {
                dotColor: "#217BBE",
                backgroundColor: "#217BBE26"
            };
    }
};

export const formatedPrice = price => {
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "EUR"
    }).format(price);
};

export const formatedDate = date => format(new Date(date), "dd MMM yyyy");

export const getSearchParamsFromUrl = key => new URLSearchParams(window.location.search).get(key);

export const formatOrderNumber = (orderId, length = 7, padChar = '0') => {
    if (!orderId) return '';
    const orderIdStr = orderId.toString();
    return `APS${orderIdStr.padStart(length, padChar)}`;
}